import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../helpers/reducerRegistry'
import {
  addNewCompany,
  deleteCompany,
  getPortfolioByOrgId,
  postCreatePortfolio,
} from './thunk'

const initialState = {
  portfolios: [],

  searchTerm: '',
  validateNameCreatePortfolio: '',

  loading: {
    portfolios: true,
    mutateData: false,
  },
}

const slice = createSlice({
  name: 'common/popupManagePortfolio',
  initialState,
  reducers: {
    resetStore: () => initialState,
    changeSearchTerm: (state, action) => {
      state.searchTerm = action.payload
    },
    clearValidateNameCreatePortfolio: (state) => {
      state.validateNameCreatePortfolio = ''
    },
  },
  extraReducers: (builder) => {
    //getPortfolioByOrgId
    builder.addCase(getPortfolioByOrgId.pending, (state) => {
      state.loading.portfolios = true
    })
    builder.addCase(getPortfolioByOrgId.fulfilled, (state, action) => {
      state.portfolios = [...action.payload].reverse()
      state.loading.portfolios = false
    })
    builder.addCase(getPortfolioByOrgId.rejected, (state) => {
      state.portfolios = []
      state.loading.portfolios = false
    })
    //addNewCompany
    builder.addCase(addNewCompany.pending, (state) => {
      state.loading.mutateData = true
    })
    builder.addCase(addNewCompany.fulfilled, (state, action) => {
      const portfolioIds = action.meta.arg.portfolioIds
      state.portfolios = state.portfolios.map((item) => ({
        ...item,
        hasOrganizationId: portfolioIds.includes(item.portfolioId)
          ? true
          : item.hasOrganizationId,
        numOfCompanies: item.numOfCompanies + 1,
      }))
      state.loading.mutateData = false
    })
    builder.addCase(addNewCompany.rejected, (state) => {
      state.loading.mutateData = false
    })
    //deleteCompany
    builder.addCase(deleteCompany.pending, (state) => {
      state.loading.mutateData = true
    })
    builder.addCase(deleteCompany.fulfilled, (state, action) => {
      const portfolioIds = action.meta.arg.portfolioIds
      state.portfolios = state.portfolios.map((item) => ({
        ...item,
        hasOrganizationId: portfolioIds.includes(item.portfolioId)
          ? false
          : item.hasOrganizationId,
        numOfCompanies: item.numOfCompanies - 1,
      }))
      state.loading.mutateData = false
    })
    builder.addCase(deleteCompany.rejected, (state) => {
      state.loading.mutateData = false
    })
    //postCreatePortfolio
    builder.addCase(postCreatePortfolio.rejected, (state, action) => {
      state.validateNameCreatePortfolio = action.payload.message
    })
  },
})

export const {
  resetStore,
  changeSearchTerm,
  clearValidateNameCreatePortfolio,
} = slice.actions

export const selectSearchTerm = (state) => state[slice.name].searchTerm
export const selectPortfolios = (state) => state[slice.name].portfolios
export const selectTextValidateNamePortfolio = (state) =>
  state[slice.name].validateNameCreatePortfolio

export const selectLoading = (type) => (state) => {
  const loadingObj = state[slice.name].loading
  if (!type) return Object.values(loadingObj).some(Boolean)
  return state[slice.name].loading[type]
}

register(slice.name, slice.reducer)
